export default [
  {
    path: '/',
    name: 'index',
    meta: {
      title: '弘韬建设数据大屏',
      requireLogin: true,
    },
    // eslint-disable-next-line import/extensions
    component: () => import('@/views/Index.vue'),
  },
  {
    path: '/situation/:id',
    name: 'situation',
    meta: {
      title: '项目概况_弘韬建设数据大屏',
      requireLogin: true,
    },
    // eslint-disable-next-line import/extensions
    component: () => import('@/views/Situation.vue'),
  },
  {
    path: '/quality/:id',
    name: 'quality',
    meta: {
      title: '人员管理_弘韬建设数据大屏',
      requireLogin: true,
    },
    // eslint-disable-next-line import/extensions
    component: () => import('@/views/Quality.vue'),
  },
  {
    path: '/personnel/:id',
    name: 'personnel',
    meta: {
      title: '安质管理_弘韬建设数据大屏',
      requireLogin: true,
    },
    // eslint-disable-next-line import/extensions
    component: () => import('@/views/Personnel.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '安质管理_弘韬建设数据大屏',
      requireLogin: false,
    },
    // eslint-disable-next-line import/extensions
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/image',
    name: 'image',
    meta: {
      title: '安质管理_弘韬建设数据大屏',
      requireLogin: true,
    },
    // eslint-disable-next-line import/extensions
    component: () => import('@/views/Image.vue'),
  },
  {
    path: '/safety',
    name: 'safety',
    meta: {
      title: '弘韬建设安全质量监控平台',
      requireLogin: true,
    },
    // eslint-disable-next-line import/extensions
    component: () => import('@/views/Safety.vue'),
  },
  {
    path: '/indexLive',
    name: 'indexLive',
    meta: {
      title: '弘韬建设安全质量监控平台',
      requireLogin: true,
    },
    // eslint-disable-next-line import/extensions
    component: () => import('@/views/IndexLive.vue'),
  },
  {
    path: '/safety/image',
    name: 'safetyImage',
    meta: {
      title: '弘韬建设安全质量监控平台',
      requireLogin: true,
    },
    // eslint-disable-next-line import/extensions
    component: () => import('@/views/SafetyImage.vue'),
  },
  // {
  //   path: '/live',
  //   name: 'live',
  //   meta: {
  //     title: '弘韬建设安全质量监控平台',
  //     requireLogin: true,
  //   },
  //   // eslint-disable-next-line import/extensions
  //   component: () => import('@/views/Live.vue'),
  // },

];



// WEBPACK FOOTER //
// ./src/router/routes.js